import {
  AffiliationTabs,
  ReferralLinksStatistics,
} from "features/affiliation/common/types";
import CardWithTitle from "features/affiliation/common/CardWithTitle";
import useReferralLinks from "features/affiliation/common/hooks/useReferralLinks";
import StatisticsRow from "features/affiliation/common/StatisticsRow";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const OverviewLinksStatistics = () => {
  const { overviewStatistics, getStatisticValue } = useReferralLinks();
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <CardWithTitle
      title={t("overview.links")}
      relatedTab={AffiliationTabs.REFERRAL_LINKS}
    >
      <StatisticsRow<ReferralLinksStatistics>
        statisticsTitles={overviewStatistics}
        getStatisticValue={getStatisticValue}
      />
    </CardWithTitle>
  );
};

export default OverviewLinksStatistics;
